/*
 * @Description: 特惠服务
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import viewName from '../constant.js'
import {
    getDiscountServiceList,
    getDiscountServiceTags
} from '@/models/discountService'
import appGuideDialog from '@/components/appGuideDialog/appGuideDialog'
import { wxShare } from '@/utils/wxsdk'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import GuideFloating from '@/components/guideFloating/guideFloating'
import searchInput from '@/components/searchInput/searchInput'
import FilterBox from './components/filter'
import discountServiceList from './components/discountServiceList.vue'
import eventBus, { FILTER_TAGS_SHOW } from '@/utils/eventBus.js'

export default {
    name: viewName.discountService,
    components: {
        infiniteLoadData,
        InfiniteLoading,
        discountServiceList,
        GuideFloating,
        appGuideDialog,
        searchInput,
        FilterBox
    },
    data () {
        return {
            reqSuccess: false, // 是否请求完成
            share: {
                desc: '',
                imgUrl: '',
                title: ''
            },
            /* 筛选的过滤参数 */
            params: {
                // is_vip: 0, // 渠道专享
                // distance: 0, // 距离最近排序
                // price: '', // 价格排序
                // tags: '', // 筛选标签id
            },
            position:{
                lng: '',
                lat: ''
            },
            tagsData: [], // 接口请求的标签数据
            list: [],
            page: 1,
            pagesize: 20,
            isload: true,
            text: '', // 搜索名称
        }
    },
    computed: {
        ...mapState({
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
        ...mapGetters([
            'wxUserInfo'
        ]),
    },
    created () {
    },
    activated () {

    },
    mounted () {
        document.documentElement.scrollTop = document.body.scrollTop = 0
        const { distribution_code } = this.$route.query
        this.distribution_code = distribution_code
        this.list = []
        this.setAppClass({
            isAppend: false,
            className: 'bgGreyColor'
        })
        this.getDiscountServiceTags()
    },
    methods: {
        ...mapActions(['setAppClass', 'getWxUserInfo', 'getLocation']),
        /**
         * 文本框点击关闭标签筛选弹窗
         */
        onClickInput () {
            console.log('onClickInput')
            eventBus.$emit(FILTER_TAGS_SHOW, false)
        },
        /**
         * 获取本地地址
         */
        getMyLocation () {
            return this.getLocation({ timeout: 3000 }).then(this.getPosition)
        },
        /*
         * 获取位置信息并转换为百度坐标系
         */
        getPosition (position) {
            this.position = position
            console.log('获取到的坐标', this.position)
        },
        /*
         * 请求特惠服务标签筛选的数据
         */
        async getDiscountServiceTags () {
            const res = await getDiscountServiceTags({
                distribution_code: this.distribution_code,
                sstore_id: 0
            })
            this.tagsData = res.list
        },
        /**
         * 过滤参数回调 - 筛选条件
         */
        onFliterParamsCallBack (params, isDefaultParams) {
            console.log('onFliterParamsCallBack', params)
            this.params = params
            if (!isDefaultParams) {
                this.getData()
            }
        },
        /**
         * 无限滚动方法
         */
        infinite () {
            this.getList()
        },
        /**
         * 配置微信分享
         * @param {Object} detail
         */
        configWxShare (detail) {
            if (this.isWeixin) {
                wxShare({
                    link: location.href,
                    title: detail.title,
                    imgUrl: detail.imgUrl,
                    desc: detail.desc,
                })
            }
        },
        /*
         * 搜索商品
         */
        onSearch (text) {
            this.text = text
            this.getData()
        },
        /**
         * 重置参数并获取数据
         */
        getData () {
            this.page = 1
            this.list = []
            /* 重置会重新请求接口 */
            this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.reset()
        },
        /**
         * 获取列表数据
         */
        async getList () {
            const { store_id } = this.$route.query
            this.reqSuccess = false
            const {lat, lng} = this.position
            if (!lat && !lng) {
                await this.getMyLocation().catch((e) => {
                    console.log(e)
                })
            }
            const params = Object.assign({
                title: this.text,
                page: this.page,
                pagesize: this.pagesize,
                lat: this.position.lat,
                lng: this.position.lng,
                distribution_code: this.distribution_code,
                sstore_id: store_id
            }, this.params)
            console.log('paramsparams', params)
            try {
                const res = await getDiscountServiceList(params)
                console.log('reqSuccess')
                this.reqSuccess = true
                this.list.push(...res.list)
                if (res.list.length < this.pagesize) {
                    this.page = 1
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.complete()
                } else {
                    this.page++
                    this.$refs.infiniteLoading && this.$refs.infiniteLoading.stateChanger.loaded()
                }
            } catch (error) {
                this.$refs.infiniteLoading.stateChanger.complete()
            }
        }
    }
}
